<template>
  <div class="">
    <page-header
      title="New Estimate"
      breadcrumb="Billings & Payment > Quotes > New Estimate"
    />
    <div class="card">
      <div class="flex gap-2">
        <radio-input
          id="changed-mind"
          label="New Customer"
          value="new"
          v-model="customer"
        />
        <radio-input
          class="mx-8"
          id="not-ready"
          label="Existing Customer"
          value="existing"
          v-model="customer"
        />
      </div>
      <div v-if="customer == 'new'">
        <h3 class="font-semibold my-2">Customer Details</h3>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">
              <label for="name" class="label">Customer Name</label>
              <input
                type="text"
                id="name"
                class="input"
                placeholder="-- Enter --"
              />
            </div>
            <div class="col-md-6">
              <label for="id" class="label">Customer ID</label>
              <input
                type="text"
                id="id"
                class="input"
                placeholder="-- Enter --"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label for="address" class="label">Address</label>
              <input
                type="text"
                id="address"
                class="input"
                placeholder="-- Enter --"
              />
            </div>
            <div class="col-md-6">
              <label for="state" class="label">State</label>
              <input
                type="text"
                id="state"
                class="input"
                placeholder="-- Enter --"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label for="country" class="label">Country</label>
              <input
                type="text"
                id="country"
                class="input"
                placeholder="-- Enter --"
              />
            </div>
            <div class="col-md-6">
              <label for="phone" class="label">Phone Number</label>
              <vue-tel-input></vue-tel-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label for="email" class="label">Email</label>
              <input
                type="email"
                id="email"
                class="input"
                placeholder="-- Enter --"
              />
            </div>
            <div class="col-md-6">
              <label for="quote" class="label">Quote Number</label>
              <input
                type="text"
                id="quote"
                class="input"
                placeholder="-- Enter --"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label for="currency" class="label">Currency</label>
              <input
                type="text"
                id="currency"
                class="input"
                placeholder="-- Enter --"
              />
            </div>
          </div>
          <hr class="my-4" />
          <p class="flex gap-2 cursor-pointer">
            <span>
              <svg
                width="23"
                height="22"
                viewBox="0 0 23 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.5 22C5.42487 22 0.5 17.0751 0.5 11C0.5 4.92487 5.42487 0 11.5 0C17.5751 0 22.5 4.92487 22.5 11C22.5 17.0751 17.5751 22 11.5 22ZM11.5 20C16.4706 20 20.5 15.9706 20.5 11C20.5 6.02944 16.4706 2 11.5 2C6.52944 2 2.5 6.02944 2.5 11C2.5 15.9706 6.52944 20 11.5 20ZM16.5 10H12.5V6H10.5V10H6.5V12H10.5V16H12.5V12H16.5V10Z"
                  fill="#FCC210"
                />
              </svg>
            </span>
            Add Shipments
          </p>

          <h3 class="font-semibold">Shipments</h3>
        </div>
      </div>
      <div class="mt-4" v-else>
        <div class="table__search-input-wrapper w-64">
          <span class="pr-2 opacity-50"><search-icon /> </span>
          <input
            type="text"
            class="table__search-input"
            placeholder="Search..."
          />
          <img src="@/assets/images/icons/search.svg" alt="search icon" />
        </div>
        <div class="flex flex-col">
          <h3 class="font-bold my-2">Customer Details</h3>
          <div class="flex gap-2">
            <img src="" alt="" />
            <div class="flex flex-col gap-2">
              <p class="font-bold">Emondi Ibikunle</p>
              <p class="flex gap-2 items-center text-gray-500">
                <span>
                  <svg
                    width="21"
                    height="12"
                    viewBox="0 0 21 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.64662 0.483398H18.5466C20.0466 0.483398 20.8026 1.03076 20.8026 2.14403V9.95552C20.8026 11.0595 20.0466 11.6162 18.5466 11.6162H2.64662C1.14662 11.6162 0.390625 11.0595 0.390625 9.95552V2.14403C0.390625 1.03076 1.14662 0.483398 2.64662 0.483398ZM10.5906 8.46188L18.6786 3.33153C18.9666 3.14598 19.1946 2.71923 18.8346 2.33886C18.4866 1.95849 17.8506 1.94921 17.4306 2.18114L10.5906 5.76218L3.76262 2.18114C3.34263 1.94921 2.70662 1.95849 2.35863 2.33886C1.99863 2.71923 2.22662 3.14598 2.51462 3.33153L10.5906 8.46188Z"
                      fill="#B7BDCD"
                    />
                  </svg>
                </span>
                emondiibikuns@gmail.com
              </p>
              <p class="flex gap-2 items-center text-gray-500">
                <span>
                  <svg
                    width="24"
                    height="19"
                    viewBox="0 0 24 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.4983 14.2413L18.2403 10.5453C17.9918 10.3707 17.6652 10.2775 17.3295 10.2855C16.9938 10.2936 16.6752 10.4021 16.4411 10.5883L13.3458 13.0493C12.6008 12.9393 11.1029 12.5783 9.56109 11.3893C8.01927 10.1963 7.55232 9.03531 7.41392 8.46331L10.5946 6.06931C10.8357 5.88844 10.9763 5.64213 10.9867 5.38252C10.9971 5.1229 10.8764 4.87035 10.6502 4.67831L5.8708 0.614313C5.6445 0.42167 5.32997 0.304817 4.99402 0.288573C4.65807 0.272328 4.32716 0.357971 4.07157 0.527313L1.26473 2.38831C1.0411 2.56183 0.907623 2.79276 0.889619 3.03731C0.870217 3.28731 0.500282 9.20931 6.43993 13.8033C11.6216 17.8083 18.1123 18.1013 19.8999 18.1013C20.1611 18.1013 20.3215 18.0953 20.3642 18.0933C20.6805 18.0796 20.979 17.976 21.2024 17.8023L23.6083 15.6313C23.8282 15.4343 23.9398 15.1787 23.9192 14.919C23.8987 14.6593 23.7476 14.4161 23.4983 14.2413Z"
                      fill="#B7BDCD"
                    />
                  </svg>
                </span>
                09038992300
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3"></div>
            <div class="col-md-3"></div>
            <div class="col-md-3"></div>
            <div class="col-md-3"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";

export default {
  name: "new-estimate",
  components: {
    PageHeader,
  },
  data() {
    return {
      customer: "new",
    };
  },
};
</script>

<style>
</style>